// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.implementation-guide-page {
  height: 100vh;
  width: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.implementation-guide-page__frame {
  display: block;
  width: 100%;
  height: 100%;
  border: none;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ImplementationGuide/ImplementationGuidePage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;AACd","sourcesContent":[".implementation-guide-page {\r\n  height: 100vh;\r\n  width: 100%;\r\n  margin: 0;\r\n  padding: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.implementation-guide-page__frame {\r\n  display: block;\r\n  width: 100%;\r\n  height: 100%;\r\n  border: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
